"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const login_1 = require("@/services/authenticationService/login");
const Button_1 = __importDefault(require("../../components/Button"));
const style_1 = require("./style");
function Login() {
    const onLogin = react_1.default.useCallback(() => {
        (0, login_1.login)();
    }, []);
    return (react_1.default.createElement(style_1.ContainerStyled, null,
        react_1.default.createElement(style_1.StyledGrid, null,
            react_1.default.createElement(style_1.LogoWrapper, null,
                react_1.default.createElement(style_1.StyledLogo, null),
                react_1.default.createElement(style_1.Title, { variant: "h2" },
                    react_1.default.createElement("strong", null, "Inteligent Feedstock Flow Admin"))),
            react_1.default.createElement(Button_1.default, { onClick: onLogin, label: "Sign in", size: "large", variant: "contained", color: "primary" }))));
}
exports.default = Login;
